export enum DeviceByKeyFilterEnum {
    ID = 'id',
    NAME = 'name',
    CODE = 'code',
    EXTERNAL_ID = 'externalId',
}
